module.exports = __webpack_public_path__ + "static/media/about@2x.3b9951dc.webp";